import React from "react";
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonSpinner,
  IonToolbar,
} from "@ionic/react";
import { EvidenceContainer, HeaderTitle } from "parafolio-components";
import { useRefreshProgramData } from "@hooks/programs/useRefreshProgramData";
import { Icon_Refresh } from "@assets/images";
import { useParams } from "react-router";
import DataController from "@controllers/DataController";
import { Capacitor } from "@capacitor/core";
import { useHidingTabBar } from "@hooks/tabs/useHidingTabBar";
import WellbeingContainer from "@components/wellbeing/WellbeingContainer";
import { useProgramData } from "@hooks/data/useProgramData";
import WellbeingDisclaimerModal from "@components/wellbeing/WellbeingDisclaimerModal";

const WellbeingActivity: React.FC = () => {
  const params = useParams<{ programId: string; progressCheckId: string; competenceId: string }>();

  useHidingTabBar();
  const { isRefreshingProgramData, refreshUserProgramData } = useRefreshProgramData();
  const { userPrograms } = useProgramData();

  // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
  const program = userPrograms?.find((program) => program.ID === params.programId)!;

  const wellbeingActivity = program.WellbeingModules?.find(
    (wellbeingModule) => wellbeingModule.CompetenceID === params.competenceId
  );

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar
          mode="ios"
          className="navBar"
          style={{
            maxWidth: DataController.isWeb() ? 980 : undefined,
            height: Capacitor.getPlatform() === "android" ? "54px" : "unset",
          }}
        >
          <IonButtons>
            <IonBackButton
              className="header-back-buttons wellbeing-activity-back-button"
              defaultHref={`/dashboard/program/${params.programId}/progress-check/${params.progressCheckId}`}
              text={DataController.getBackIconText()}
              icon={DataController.getBackIconType()}
              style={{
                marginLeft: Capacitor.getPlatform() === "android" ? 8 : 0,
                "--icon-font-size": Capacitor.getPlatform() === "android" ? "24px" : "30px",
              }}
            />
          </IonButtons>
          <HeaderTitle>{"Wellbeing Activity"}</HeaderTitle>
          <IonButtons slot="end">
            <IonButton
              disabled={isRefreshingProgramData}
              className="header-button"
              onClick={refreshUserProgramData}
            >
              {isRefreshingProgramData ? (
                <IonSpinner className="w-11 h-11 text-white" />
              ) : (
                <img
                  src={Icon_Refresh}
                  className="!w-11 !h-11"
                />
              )}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent
        id="wellbeing-content-container"
        className="page-background !py-0 force-scroll-auto"
      >
        <WellbeingDisclaimerModal disclaimerText={wellbeingActivity?.["Popup Text"] ?? ""} />
        <EvidenceContainer style={{ paddingTop: 0, alignSelf: "center", paddingBottom: 0 }}>
          <div className="!min-h-full">
            {wellbeingActivity && (
              <WellbeingContainer
                program={program}
                wellbeingActivity={wellbeingActivity}
              />
            )}
          </div>
        </EvidenceContainer>
      </IonContent>
    </IonPage>
  );
};

export default WellbeingActivity;
